import { messageStreamEvent } from '@krishanmadan/core/src/events';
import { _set } from '@epihub/core/src/fn/object';
import { useGlobalStore } from '../store/useGlobalStore';
import { useWSSubscription } from '../_ctx/wsClient';

export function useStreamingResponseListener() {
  const visitorId = useGlobalStore((store) => store.settings.visitorId);

  useWSSubscription(messageStreamEvent({ visitorId }), async ({ message }) => {
    useGlobalStore.getState().conversation.updateConversation((prev) => {
      const duplicated = [...prev.messages];
      const indexOf = duplicated.findIndex((msg) => msg.id === message.id);
      if (indexOf < 0) {
        return prev;
      }

      return {
        ...prev,
        messages: _set(duplicated, `[${indexOf}]`, message),
      };
    });
  });
}
